export const RADIO_OTHERS_INPUT_KEY = 'othersInput'
export const RADIO_OTHERS_INPUT_VALUE = '!!FORMSG_INTERNAL_RADIO_OTHERS_VALUE!!'
